module.exports = __webpack_public_path__ + "img/Vectorright_disabled.010a97d9.svg";